<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen animated fadeInDown">
			<div>

				<div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
					<img src="/static/image/park_bills_text_black.png">
				</div>

				<h3>Welcome to ParkBills</h3>

				<h4>Please create profile to proceed</h4>

        <div class="wrapper wrapper-content animated fadeInRight">
          <div class="row text-left">
            <div 
              class="col-lg-12 ibox">
              <div class="ibox-content">
                <a class="row" v-on:click="selectCompany">
                  <!--
                  <div class="col-4">
                    <div class="text-center">
                      <img alt="image" class="rounded-circle m-t-xs img-fluid" src="img/a2.jpg">
                      <div class="m-t-xs font-bold">Graphics designer</div>
                    </div>
                  </div>
                  -->
                  <div class="col-8">
                    <h3><strong>Create Company Profile</strong></h3>
                  </div>
                </a>
              </div>
              <br>
              <div class="ibox-content">
                <a class="row" v-on:click="selectPersonal">
                  <!--
                  <div class="col-4">
                    <div class="text-center">
                      <img alt="image" class="rounded-circle m-t-xs img-fluid" src="img/a2.jpg">
                      <div class="m-t-xs font-bold">Graphics designer</div>
                    </div>
                  </div>
                  -->
                  <div class="col-8">
                    <h3><strong>Create Personal Profile</strong></h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <p class="m-t">
          <small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
        </p>
				
			</div>
		</div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageChooseAccount",
  data(){
    return {
      meRoles : null,
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
    
    try {
      this.meRoles = JSON.parse(localStorage.getItem('meRoles'));
    } catch(e) {
      helper.redirect(helper.WEB_URL + '/login');
    }
  },
  methods : {
    selectCompany() {
      helper.redirect('/companyForm');
    },
    selectPersonal() {
      helper.redirect('/personalForm');
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageCreateProfile.vue